import { localisedValue } from "utils"

const taggedUsersTransformer = resp => {
  const taggedStaffIdsMap = {}
  const staffList = resp?.map(item => {
    taggedStaffIdsMap[item?.taggedToUser?.id] = item
    return {
      department: item?.taggedToUser?.department,
      staff: {
        designationShort: localisedValue({ object: item?.taggedToUser?.designation, key: "short" }),
        designation: localisedValue({ object: item?.taggedToUser?.designation, key: "name" }),
        value: item?.taggedToUser?.id.toString(),
        title: localisedValue({ object: item?.taggedToUser, key: "name" }),
      },
    }
  })
  return { staffList, taggedStaffIdsMap }
}

export default taggedUsersTransformer
